import { render, staticRenderFns } from "./AddressProfileDataView.vue?vue&type=template&id=badbeb28&scoped=true&"
import script from "./AddressProfileDataView.vue?vue&type=script&lang=js&"
export * from "./AddressProfileDataView.vue?vue&type=script&lang=js&"
import style0 from "./AddressProfileDataView.vue?vue&type=style&index=0&id=badbeb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badbeb28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCardText,VExpandTransition,VFlex,VIcon,VLayout,VSelect,VSpacer,VSubheader,VTextField,VToolbar,VToolbarTitle})
